import { useState, useEffect, useRef } from 'react'
import Image from 'next/image'
import { useTranslation } from 'src/utils/i18n'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// 备份提示步骤集合
const backupArr = [
  {
    url: '/images/ios-backup/step1.webp',
    alt: 'backup-step1',
    width: '229px',
    height: '379px',
    mbWidth: '229px',
    mbHeight: '379px',
    text: 'Open the Settings of the target device and click on the account name'
  },
  {
    url: '/images/ios-backup/step2.webp',
    alt: 'backup-step2',
    width: '229px',
    height: '379px',
    mbWidth: '229px',
    mbHeight: '379px',
    text: 'Tap iCloud'
  },
  {
    url: '/images/ios-backup/step3.webp',
    alt: 'backup-step3',
    width: '229px',
    height: '379px',
    mbWidth: '229px',
    mbHeight: '379px',
    text: 'Select iCloud Backup'
  },
  {
    url: '/images/ios-backup/step4.webp',
    alt: 'backup-step4',
    width: '229px',
    height: '379px',
    mbWidth: '229px',
    mbHeight: '379px',
    text: `Tap the slider next to iCloud Backup If its green youll know youve turned on iCloud backup and you can skip to the next step`
  },
  {
    url: '/images/ios-backup/step5.webp',
    alt: 'backup-step5',
    width: '229px',
    height: '379px',
    mbWidth: '229px',
    mbHeight: '379px',
    text: 'Make sure to enable syncing for all the apps you want to monitor'
  },
  {
    url: '/images/ios-backup/step6.webp',
    alt: 'backup-step6',
    width: '371px',
    height: '379px',
    mbWidth: '325px',
    mbHeight: '332px',
    text: 'Finally click Back Up Now Wait until the backup process complete While your iPhone is backing up your data You must remain connected to Wi-Fi'
  },
  {
    url: '/images/ios-backup/step7.webp',
    alt: 'backup-step7',
    width: '421px',
    height: '379px',
    mbWidth: '325px',
    mbHeight: '293px',
    text: 'Make sure there is enough storage left in the target iCloud account When the iCloud is full you can only see the previous backup data if you wanna view more data you can consider upgrading the iCloud storage plan'
  },
  {
    url: '/images/ios-backup/step8.png',
    alt: 'backup-step8',
    width: '180px',
    height: '379px',
    mbWidth: '180px',
    mbHeight: '379px',
    text: 'Turn on the Access iCloud Data on Web toggle'
  }
]

const StepProgress = ({ current, total }) => {
  const barWidth = 72;//宽度

  return (
    <div className="flex items-center gap-4 mb-[40px] Mlg:mb-[20px]">
      <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
        {current}/{total}
      </div>

      <div className="flex gap-x-[6px]">
        {Array.from({ length: total }).map((_, i) => {
          const active = i < current;

          return (
            <div
              key={i}
              className="h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]"
              style={
                active
                  ? {
                    background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                    backgroundSize: `${current * barWidth}px 4px`,
                    backgroundPosition: `-${i * barWidth}px 0px`,
                  }
                  : {
                    background: "#E8EDFF",
                  }
              }
            />
          )
        })}
      </div>
    </div>
  )
}

const Backup = ({ setJustVerified2 }) => {
  const { t } = useTranslation('common')
  const [current, setCurrent] = useState(0) // 当前的步骤
  const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度
  const prevRef = useRef(null) // 上一步按钮
  const nextRef = useRef(null) // 下一步按钮
  const paginationRef = useRef(null) // 圆点导航按钮

  // 监听屏幕宽度
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlerInnerWidth = () => {
        setInnerWidth(window.innerWidth)
      }

      handlerInnerWidth()

      window.addEventListener('resize', handlerInnerWidth)

      return () => {
        window.removeEventListener('resize', handlerInnerWidth)
      }
    }
  }, [])

  return (
    <div className='w-full max-w-[648px] h-max px-[10px] flex flex-col items-center relative Mlg:pb-[75px]'>
      {/* 进度条 */}
      <StepProgress current={5} total={5} />
      {/* apple Icon */}
      <Image src='/images/apps/apple.svg' alt='img' className='w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]' style={{ opacity: current === backupArr.length ? '0' : '100' }} width='60' height='69' />

      {/* 蓝色标题 */}
      <p className='w-full max-w-[420px] mt-[24px] text-[30px] Mlg:text-[20px] text-[#2405F2] text-center font-[600] leading-[40px] Mlg:leading-[30px]' style={{ opacity: current === backupArr.length ? '0' : '100' }}>{t('Turn on the iCloud Backup')}</p>

      {/* 温馨提示 */}
      <div
        className='w-max max-w-full my-[16px] flex items-start justify-center text-[14px] Mlg:text-[10px] text-[#F11E34] leading-[21px] Mlg:leading-[15px] p-[8px_18px_8px_16px] Mlg:p-[14px_17px_11px] bg-[#FF00000D] rounded-[6px]'
        style={{ opacity: current === backupArr.length ? '0' : '100' }}
      >
        <Image
          src='/images/apps/waring.svg'
          className='flex items-start mt-[5px] Mlg:mt-[3px] mr-[6px]'
          alt='img'
          width={12}
          height={12}
        />
        <p className='text-center'>
          {t('You can only get all data if iCloud is turned on')}
        </p>
      </div>

      {/* 步骤图&文案 */}
      <Swiper
        key={innerWidth <= 768 ? 'mobile' : 'desktop'} // 触发组件重新挂载
        modules={[Navigation, Pagination]}
        direction='horizontal'
        allowTouchMove={false}
        navigation={{	//自定义切换箭头
          prevEl: prevRef.current,
          nextEl: nextRef.current
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current
          swiper.params.navigation.nextEl = nextRef.current
          swiper.params.pagination.el = paginationRef.current
          swiper.params.pagination.renderBullet = (_, className) =>
            `<div class="${className} myBullet"></div>`
        }}
        pagination={{
          clickable: true,
          el: paginationRef.current,
          renderBullet: (_, className) => {
            return `<div class="${className} myBullet"></div>`
          }
        }}
        onSlideChange={(swiper) => { setCurrent(swiper.realIndex) }}
        className='w-full max-w-[500px] relative'
        style={{ top: current === backupArr.length ? '-122px' : '0px' }}
      >
        {
          backupArr.map((item, index) => (
            <SwiperSlide key={index} className='h-full flex flex-col justify-center items-center'>
              <div className='h-[379px] mb-[48px] flex justify-center items-center'>
                <Image src={item.url} alt={item.alt} width={100} height={100}
                  style={{ width: innerWidth > 768 ? item.width : item.mbWidth, height: innerWidth > 768 ? item.height : item.mbHeight }}
                  className='object-cover object-left-top [box-shadow:0px_4px_18px_0px_#00000033] select-none' />
              </div>
              <p className='w-full text-[14px] text-[#000000] text-center leading-[22px]'>{t(item.text)}</p>
            </SwiperSlide>
          ))
        }

        {/* 临时的升级提示 */}

        {/* 圆点导航 */}
        <div ref={paginationRef} className={`!h-[8px] flex justify-center items-center gap-x-[5px] absolute !top-[403px] !left-[50%] !-translate-x-[50%] z-20 ${current === backupArr.length ? 'hidden' : ''}`}></div>
      </Swiper>

      {/* 轮播切换步骤箭头按钮 */}
      {/* <div className='w-full Mlg:hidden absolute top-[55%] -translate-y-[50%] z-20 select-none'>
                <div ref={prevRef} className='banner_prev absolute left-0'>
                    <Image src='/images/ios-backup/arrow-left.svg' alt='arrow-left' width={24} height={24} className={`w-[24px] h-[24px] ${current === 0 ? 'opacity-0 pointer-events-none' : 'opacity-100 cursor-pointer'}`} />
                </div>
                <div ref={nextRef} className='banner_next absolute right-0'>
                    <Image src='/images/ios-backup/arrow-right.svg' alt='arrow-right' width={24} height={24} className={`w-[24px] h-[24px] ${current === backupArr.length ? 'opacity-0 pointer-events-none' : 'opacity-100 cursor-pointer'}`} />
                </div>
            </div> */}
      {/* <div className='w-full Mlg:hidden absolute top-[55%] -translate-y-[50%] z-20 select-none'>
        <div ref={prevRef} className='banner_prev absolute left-0'>
          <Image src='/images/ios-backup/arrow-left.svg' alt='arrow-left' width={24} height={24} className={`w-[24px] h-[24px] ${current === 0 ? 'opacity-0 pointer-events-none' : 'opacity-100 cursor-pointer'}`} />
        </div>
        <div ref={nextRef} className='banner_next absolute right-0'>
          <Image src='/images/ios-backup/arrow-right.svg' alt='arrow-right' width={24} height={24} className={`w-[24px] h-[24px] ${current === backupArr.length - 1 ? 'opacity-0 pointer-events-none' : 'opacity-100 cursor-pointer'}`} />
        </div>
      </div> */}

      {/* <div className={`${current !== backupArr.length - 1 ? 'opacity-0 pointer-events-none' : ''}`}>
        // 跳转 dashboard 按钮
        <button
          className='w-max min-w-[334px] Mlg:min-w-[264px] max-w-full flex justify-center items-center py-[10px] Mlg:py-[7px] mt-[10px] mb-[25px] Mlg:mt-[16px] px-[21px] bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px]'
          onClick={() => { setJustVerified2(true) }}
        >
          {t('Continue')}
        </button>
      </div> */}

      {/* 按钮 */}
      <div className='w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB] z-[1]'>
        <div className='flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto'>
          <div className='w-full lg:w-[620px] flex justify-between smj:px-4'>
            <button ref={prevRef}
              className={`border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px] ${current == 0 && 'opacity-0'}`}>
              <Image className='mr-[7px]' src='/images/bind/bind-arrow-blue.svg' width={18} height={18} alt='back' />
              <span className='text-[15px] text-[#454CFF] font-[600]'>{t('BACK')}</span>
            </button>
            <button ref={nextRef}
              className={`bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ${current == backupArr.length - 1 && 'hidden'}`}>
              <span className='text-[15px] text-[#1B1C2B] font-[600]'>{t('NEXT')}</span>
              <Image className='ml-[6px]' src='/images/bind/bind-arrow-black.svg' width={18} height={18} alt='back' />
            </button>
            <button onClick={() => { if (current == backupArr.length - 1) setJustVerified2(true) }}
              className={`bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ${current == backupArr.length - 1 || 'hidden'}`}>
              <span className='text-[15px] text-[#1B1C2B] font-[600]'>{t('NEXT')}</span>
              <Image className='ml-[6px]' src='/images/bind/bind-arrow-black.svg' width={18} height={18} alt='back' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Backup
